export default {

methods: {


	//functon to validate the hh:mms:ss format for specific shutte.
	validateFormattedTime(formattedTime,shuttleDuration){

			console.log("Formatted time validation: " + formattedTime)
			var success = true;
			var seconds = 0;
			var message = '';


			//need to validate that each part of the date has 0 - 59 or 0 - 24 depending

			var parts = formattedTime.split(':');
			console.log(parts);

			// first make sure it is not any longer than hh:mm:ss

			if(parts.length <= 3){

				//make sure each section is a valid number
			    for(var i = 0; i < parts.length; i++) {
			        if(isNaN(Number(parts[i]))){
			        	
			        	success = false;
						message = "Each segment must be a valid number, this is not: " + parts[i];

			        }
			    }


					//valicate seconds between 
					//var s = parstInt(parts.pop());

				if(success){

					var s = parseInt(parts.pop());
					if(s >=0 && s <=59){
						if(parts.length > 0){
							//we have minutes, validate
							var m = parseInt(parts.pop());
							if(m >=0 && m <=59){

								if(parts.length > 0){
										var h = parseInt(parts.pop());
										if(h >=0 && h <=24){

										} else {

													success = false;
													message = 'Invalid number range hours must be 0 - 24 not: ' + h;
										}




								}




							} else {

								success = false;
								message = 'Invalid number range minutes must be 0 - 59 not: ' + m;
							}




						}


					} else {

						success = false;
						message = 'Invalid number range seconds must be 0 - 59 not: ' + s;

					}

				}




			} else {
				success = false;
				message = "Must be HH:MM:SS format at maximum."


			}



			if(success){
					//try to convert to sceonds
					try{

						seconds = this.hmsToSecondsOnly(formattedTime)
					} catch (e){

						success = false;
						message = 'Invalid HH:MM:SS format'

					}

					if(shuttleDuration){
							if(seconds > shuttleDuration){
									success = false;
									message = 'Duration selected is longer than the video'

							}

					}
			}


			var ret = {success:success,seconds:seconds,message:message}
			return ret;




	},

	//function takes hh:mm:ss or any combo an coverts to seconds.
	hmsToSecondsOnly(str) {
		    var p = str.split(':'),
		        s = 0, m = 1;

		    while (p.length > 0) {
		        s += m * parseInt(p.pop(), 10);
		        m *= 60;
		    }

		    return s;
		}	


}

}
